import { Command, Transaction } from "prosemirror-state";
import { RichTextEditorMarks } from "../schema";
import { entries } from "client/Misc/utils";
import { MarkType, Schema } from "prosemirror-model";

const marksToKeep: ReadonlySet<RichTextEditorMarks> = new Set<RichTextEditorMarks>([
	"link",
	"mention"
]);

export const clearStyles = (schema: Schema<never, never>): Command => {
	const marksToClear: MarkType[] = entries(schema.marks)
		.filter(x => !marksToKeep.has(x.key as RichTextEditorMarks))
		.map(x => x.value);

	return (state, dispatch): boolean => {
		const {
			selection: {
				from,
				to,
				empty
			},
			doc
		} = state;

		if (empty) {
			return false;
		}

		const hasAnyMarkActive = marksToClear.some(
			mark => doc.rangeHasMark(from, to, mark)
		);

		if (!hasAnyMarkActive) {
			return false;
		}

		if (dispatch) {
			const tr: Transaction = state.tr;

			for (const mark of marksToClear) {
				tr.removeMark(from, to, mark);
			}

			tr.scrollIntoView();
			dispatch(tr);
		}

		return true;
	};
};